// extracted by mini-css-extract-plugin
module.exports = {"text":"Text_text__3vMKP","word":"Text_word__u68jU","active":"Text_active__8HwsG","elliptic":"Text_elliptic__1mO5p"};